export default __webpack_public_path__ + "static/media/hamburgerUnselected.5d683127.svg";